/* import __COLOCATED_TEMPLATE__ from './sync-status.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { SyncStatus } from 'embercom/models/knowledge-hub/sync-source-wrapper';

interface Signature {
  Element: HTMLSpanElement;
  Args: {
    syncStatus: SyncStatus;
  };
}

export default class SyncStatusComponent extends Component<Signature> {
  get statusClasses(): string {
    let baseClasses = 'text-sm px-2 py-px rounded-full';

    switch (this.args.syncStatus) {
      case SyncStatus.LIVE:
        return `${baseClasses} bg-success-container text-default`;
      case SyncStatus.SYNCING:
        return `${baseClasses} bg-notice-container text-default`;
      case SyncStatus.SYNCED:
        return `${baseClasses} bg-neutral-container text-muted`;
      case SyncStatus.ERROR:
        return `${baseClasses} bg-error-container text-muted`;
      case SyncStatus.EXCLUDED:
        return `${baseClasses} bg-neutral-container text-muted`;
      default:
        return baseClasses;
    }
  }

  get statusText(): string {
    switch (this.args.syncStatus) {
      case SyncStatus.LIVE:
        return 'knowledge-hub.filterable-list.list.cells.sync-status.live';
      case SyncStatus.SYNCING:
        return 'knowledge-hub.filterable-list.list.cells.sync-status.syncing';
      case SyncStatus.ERROR:
        return 'knowledge-hub.filterable-list.list.cells.sync-status.error';
      case SyncStatus.SYNCED:
        return 'knowledge-hub.filterable-list.list.cells.sync-status.synced';
      case SyncStatus.EXCLUDED:
        return 'knowledge-hub.filterable-list.list.cells.sync-status.excluded';
      default:
        return this.args.syncStatus || '';
    }
  }

  get shouldShowTooltip(): boolean {
    return !!this.args.syncStatus && !!this.tooltipText;
  }

  get tooltipText(): string | null {
    switch (this.args.syncStatus) {
      case SyncStatus.ERROR: // TODO: Add more specific error types example is of anti-crawl error
        return 'knowledge-hub.filterable-list.list.cells.sync-status.tooltip.anti-crawl-error';
      default:
        return null;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::SyncStatus': typeof SyncStatusComponent;
    'knowledge-hub/filterable-list/table/cells/sync-status': typeof SyncStatusComponent;
  }
}
